import { OnInit, ElementRef, } from "@angular/core";
import { AccordionItemState, } from "./components/faq-image-panel-item/faq-image-panel-item.component";
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';
var FaqImagePanelComponent = /** @class */ (function () {
    function FaqImagePanelComponent(hostRef) {
        this.hostRef = hostRef;
        this.accordionItemState = AccordionItemState;
        this.ready = false;
    }
    Object.defineProperty(FaqImagePanelComponent.prototype, "isPanelHasImage", {
        get: function () {
            return (this.data.image && this.data.image.value && this.data.image.value.src);
        },
        enumerable: true,
        configurable: true
    });
    FaqImagePanelComponent.prototype.ngOnInit = function () {
        this.data.items.value.forEach(function (item, i) {
            item.state = AccordionItemState.closed;
            item.id = i;
        });
    };
    FaqImagePanelComponent.prototype.ngAfterViewInit = function () {
        applyTitleSettings(this.data, this.titleEl);
        applyRteSettings(this.data, this.descriptionEl);
    };
    return FaqImagePanelComponent;
}());
export { FaqImagePanelComponent };
